"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObjectChainAsync = void 0;
const recipes_1 = require("../recipes");
const basic_ingredients_async_1 = require("./basic-ingredients-async");
const flatten_async_1 = require("./flatten-async");
const group_async_1 = require("./group-async");
const reduce_async_1 = require("./reduce-async");
const to_object_async_1 = require("./to-object-async");
exports.toObjectChainAsync = (0, recipes_1.toObjectChainRecipe)({
    ...basic_ingredients_async_1.basicAsync,
    group: group_async_1.groupAsync,
    toObject: to_object_async_1.toObjectAsync,
    flatten: flatten_async_1.flattenAsync,
    reduce: reduce_async_1.reduceAsync,
});
